import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function GiftCertificates() {
  const certificates = [
    {
      id: 1,
      title: 'GIFT CERTIFICATE - Little Gophers Summer Camp (August)',
      price: 'CA$618.63',
      description: 'Give the gift of an unforgettable 3-day summer adventure at Gopher Dunes! Little Gophers Summer Camp is packed with outdoor fun, games, crafts, and confidence-building activities - plus a playful intro to dirt biking in a safe, kid-friendly setting. A perfect gift for young adventurers who love being active, exploring, and making new friends',
      image: '/throttle.png'
    },
    {
      id: 2,
      title: 'GIFT CERTIFICATE - Little Gophers Summer Camp (July)',
      price: 'CA$824.85',
      description: 'Give the gift of an unforgettable 4-day summer adventure at Gopher Dunes! Little Gophers Summer Camp is packed with outdoor fun, games, crafts, and confidence-building activities - plus a playful intro to dirt biking in a safe, kid-friendly setting. A perfect gift for young adventurers who love being active, exploring, and making new friends',
      image: '/throttle.png'
    },
    {
      id: 3,
      title: 'GIFT CERTIFICATE - Moto Kids Camp',
      price: 'CA$847.45',
      description: 'Give the gift of throttle, confidence, and unforgettable summer memories. Moto Kids Camp is all about seat time, skill-building, and having a blast on the bike - packed with coached riding sessions, outdoor fun, and an awesome camp atmosphere kids look forward to all year. It\'s more than just riding - it\'s a full-on moto experience they\'ll be talking about long after camp is over.',
      image: '/throttle.png'
    },
    {
      id: 4,
      title: 'GIFT CERTIFICATE - Pre-Walton Motocross Camp',
      price: 'CA$903.95',
      description: 'Built for racers dialing it in before the biggest week of the season. The GDR Pre-Walton Training Camp is all about sharpening speed, building confidence, and fine-tuning race craft in a focused, high-intensity environment.',
      image: '/throttle.png'
    },
    {
      id: 5,
      title: 'GIFT CERTIFICATE - Red Rider Training',
      price: 'CA$434.70',
      description: 'Perfect for beginners! Our Red Rider Training program provides everything needed for first-time riders - safety equipment, Honda motorcycles (50cc-250cc), and 2-hour professional instruction. Start your off-road adventure today!',
      image: '/throttle.png'
    },
    {
      id: 6,
      title: 'GIFT CERTIFICATE - Off-Road Rider Training',
      price: 'CA$227.70',
      description: 'Improve your riding skills with our 2-hour Off-Road training session. Perfect for novice riders who have their own bike and want to enhance their track or trail riding abilities.',
      image: '/throttle.png'
    },
    {
      id: 7,
      title: 'GIFT CERTIFICATE - Advanced Motocross Coaching',
      price: 'CA$403.65',
      description: 'Take your racing to the next level! Our 2-hour Advanced Motocross Coaching session is designed for experienced riders and racers looking to improve technical skills and racing performance.',
      image: '/throttle.png'
    },
    {
      id: 8,
      title: 'GIFT CERTIFICATE - Bike Rental (2 Hours)',
      price: 'CA$337.41',
      description: 'Give the gift of riding! 2-hour bike rental includes track/trail passes and full safety equipment. Choose from our variety of Honda models for recreational riding.',
      image: '/throttle.png'
    },
    {
      id: 9,
      title: 'GIFT CERTIFICATE - Bike Rental (Full Day)',
      price: 'CA$618.93',
      description: 'Full day of adventure! Full day bike rental includes track/trail passes and full safety equipment. Perfect for those who want to spend the entire day riding.',
      image: '/throttle.png'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Title Section */}
      <div className="mt-16 md:mt-24 py-12 bg-white border-b">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-4 font-light">
            GIFT CERTIFICATES
          </h1>
          <p className="text-center text-gray-600 text-lg">
            Give the gift of adventure at Throttle Edge
          </p>
        </div>
      </div>

      {/* Gift Certificates List */}
      <div className="py-12 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="space-y-8">
            {certificates.map((cert) => (
              <div 
                key={cert.id}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Image Section */}
                  <div className="md:w-64 bg-gray-50 flex items-center justify-center p-8">
                    <img 
                      src={cert.image} 
                      alt={cert.title}
                      className="w-48 h-auto object-contain"
                    />
                  </div>

                  {/* Content Section */}
                  <div className="flex-1 p-6 md:p-8">
                    <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-4">
                      <div className="flex-1">
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                          {cert.title}
                        </h3>
                        <p className="text-2xl font-bold text-gray-900 mb-4">
                          {cert.price}
                        </p>
                      </div>
                      <button className="bg-black text-white px-8 py-3 rounded hover:bg-gray-800 transition-colors font-semibold uppercase text-sm tracking-wider whitespace-nowrap mt-4 md:mt-0 md:ml-6">
                        ADD TO CART
                      </button>
                    </div>
                    
                    <p className="text-gray-700 leading-relaxed">
                      {cert.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default GiftCertificates;
